<template>
  <div>
    <v-divider class="divider-color"/>
    <v-list-tile
      :class="['py-2', {'disabled-item': absent }]"
      v-long-press="300"
      @long-press-start="onOptions">
      <v-list-tile-avatar
        :class="['list-avatar-align', { disabled: absent }]"
        color="primary" size="50">
          <img v-if="student.picture"
            :src="student.picture"
            :alt="student.name"
          >
        <v-icon v-else large dark>account_circle</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-content :class="{ disabled: absent }">
        <v-list-tile-title>{{ student.name }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="student.temporary">
          Temporário
          <v-icon size="14" class="ml-1">access_time</v-icon>
        </v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action class="list-action">
        <v-layout justify-end row>
          <v-icon
            size="24"
            color="dark-gray"
            class="pointer mr-2"
            @click="onOptions"
            data-test="options-button">more_horiz</v-icon>
          <v-checkbox v-model="checkedStudent" class="checkbox-align" hide-details :disabled="absent"/>
        </v-layout>
      </v-list-tile-action>

    </v-list-tile>
  </div>
</template>

<script>
export default {
  name: 'responsibleStudent',

  props: {
    student: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    checkedStudent: {
      get () {
        return this.student.checked
      },
      set (value) {
        this.toggleStudent(value)
      }
    },

    absent () {
      return this.student.absent
    }
  },

  methods: {
    onOptions () {
      this.$emit('options', { id: this.student.id, absent: this.student.absent })
    },

    toggleStudent (value) {
      this.$emit('toggleStudent', { id: this.student.id, value })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .checkbox-align
    flex none
  .disabled
    opacity .4
  .divider-color
    border-color #bababa
  .pointer
    cursor pointer
  .disabled-item
    background #e9e9e9
  .list-action
    min-width auto
  .list-avatar-align
    justify-content start
</style>
